import { createContext, useContext } from 'react';
import { ArgoContext } from './index';
import { FrameworkStage, FrontEndFeatureSet } from './ArgoEnums';
import initialMetricsPublisher, { ArgoMetricsConfig } from './utils/metrics/metrics';
import katalLogger from './utils/logger/logger';
import { Level } from "@katal/logger";
import { SafeApolloClient } from './utils/SafeApolloClient';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import {getUserPreferenceClient} from "./utils/UserPreferences";

export const metricsErrorhandler = (err: Error) => {
  return err;
};

const initialMetricsConfig: ArgoMetricsConfig = {
  appName: 'Argo',
  region: 'us-west-2',
  frameworkStage: 'test',
  cell: 'cell-0',
  browserName: 'test-browser',
  deviceType: 'test-device',
  deviceOS: 'test-os',
  locale: 'test-locale',
  applicationVisitId: 'test-applicationVisitId',
  argoSessionId: 'test-argoSessionId'
};

// This is used to create the DefaultApolloClient, the reason we are using the SafeApolloClient class is
// certain implementation based on the ArgoSampleApp, serialize the ArgoContext as a part of their unit-tests
// Extending the ApolloClient class to handle JSON.stringify
export const createDefaultApolloClient = () => {
  return new SafeApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      // Specifically for /graphV2
      uri: '/graphV2',
      fetch: () => Promise.reject('Default context: Place an ArgoAppContextProvider near the root')
    }),
    queryDeduplication: false
  });
};

const defaultContext: ArgoContext = {
  user: {
    username: 'default',
    signOut: () => {
      throw new Error(
        'Default context: Place an ArgoAppContextProvider ' +
        'near the root of your component hierarchy'
      );
    },
  },
  frameworkStage: FrameworkStage.prod,
  frontEndFeatureSet: FrontEndFeatureSet.Release,
  fetchWithWebIdentity: (input, init?) => {
    return Promise.reject(
      'Default context: Place an ArgoAppContextProvider ' +
      'near the root of your component hierarchy'
    );
  },
  fetchWithAwsAuth: (input, init?) => {
    return Promise.reject(
        'Default context: Place an ArgoAppContextProvider ' +
        'near the root of your component hierarchy'
    );
  },
  custom_groups: [],
  initialMetricsPublisher: initialMetricsPublisher(initialMetricsConfig),
  logger: katalLogger(
    Level.DEBUG,
    {
      appName: 'test'
    },
    true
  ),
  region: 'us-west-2',
  apolloClient: createDefaultApolloClient(),
  preferenceList: Promise.resolve([]),
  userPreferenceClient: getUserPreferenceClient()
};

const ArgoAppContext = createContext(defaultContext);
export const useArgoContext = () => useContext(ArgoAppContext);
export const ArgoAppContextConsumer = ArgoAppContext.Consumer;
export const ArgoAppContextProvider = ArgoAppContext.Provider;
